<template>
  <!-- <body class="layout-horizontal menu-auto-hide bg-login"> -->
  <div class="layout-horizontal menu-auto-hide bg-login">
    <div class="container-fluid container-login footer-xl login-top">
      <form class="sign-in-form card bg-login-table mt-2" action="index.html">
        <div
          class="font-weight-bold display-5 text-white text-shadow mb-2 m-t-10"
        >
          {{ $t("welcome") }}
        </div>
        <p class="text-white text-shadow">
          {{ $t("are-you-ready-to-enter-the-adventure-territory") }}<br />{{
            $t("please-enter-your")
          }}
        </p>
        <div class="input-group input-rounded mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-icon-addon1"
              ><i class="zmdi zmdi-account zmdi-hc-fw"></i
            ></span>
          </div>
          <input
            type="text"
            class="form-control form-control-lg"
            placeholder="Please enter the student name"
            aria-label="Username"
            v-model="loginForm.username"
          />
        </div>

        <!-- <div class="invalid-feedback">
                錯誤訊息
            </div> -->
        <div class="input-group input-rounded mb-3">
          <div class="input-group-prepend">
            <!-- <span class="input-group-text" id="basic-icon-addon1"><i
                            class="zmdi zmdi-shield-security zmdi-hc-fw"></i></span> -->
            <span class="input-group-text" id="basic-icon-addon1"
              ><i class="zmdi zmdi-smartphone-android zmdi-hc-fw"></i
            ></span>
          </div>
          <input
            type="text"
            class="form-control form-control-lg is-invalid"
            placeholder="Please enter the phone number"
            aria-label=""
            v-model="loginForm.uniinfo"
            @keyup.enter="login()"
          />
        </div>
        <div class="invalid-feedback">{{ $t("error-message") }}</div>

        <div class="text-right">
          <button
            @click="login()"
            class="btn btn-primary btn-rounded btn-lg"
            type="button"
          >
            {{ $t("next-step") }}
          </button>
        </div>

        <p class="text-white m-t-25 m-b-0 p-0 text-left">
          {{ $t("you-are-the-parent-of-the-student") }}
        </p>
        <p class="m-b-0 p-0 text-left login-text-hover">
          <a
            @click="$goPage('/parents-login/login')"
            class="border-bottom login-text-hover"
          >
            {{ $t("please-log-in") }}</a
          >
        </p>
        <p
          v-if="device === 'mobile' || device === 'tablet'"
          class="m-b-0 p-0 text-left mt-2 login-text-hover"
        >
          <a @click="goServerList()" class="border-bottom"> Server list</a>
        </p>
      </form>
    </div>
    <footer class="login-footer login-footer-privacy">
      <div class="d-flex justify-content-center align-items-center my-2">
        <img
          src="../assets/img/images/MSU_logo_horizontal_white.svg"
          class="msulogo"
        />
        <!-- <img
          id="logo"
          :src="logo"
          alt=""
          style="max-width: 300px; max-height: 50px"
        /> -->
      </div>
      <global-footer class="myfooter" />
    </footer>
  </div>
</template>

<script setup>
import { useUserInfoStore } from "@/store/modules/userInfo";
import { ApiStudentLogin, ApiGetLogo } from "@/service/apis/login.js";
import { ref } from "vue";
import { useGlobalStore } from "@/store/modules/global";
import gsap from "gsap";

const global = useGlobalStore();
const $goPage = inject("$goPage");
const goServerList = () => {
  window.location.href = `https://${
    import.meta.env.VITE_MSU_DOMAIN
  }.mangosteems.com/apiv2/landing?clean=true`;
};
const loginForm = ref({
  username: "",
  uniinfo: "",
});
const userInfo = useUserInfoStore();
const login = async () => {
  // for test
  // loginForm.value = {
  //   username: "",
  //   uniinfo: "",
  // };
  loginForm.value.username = loginForm.value.username.trim();
  loginForm.value.uniinfo = loginForm.value.uniinfo.trim();
  let result = await ApiStudentLogin.post(loginForm.value);
  console.log(result);
  if (result.status === "success") {
    userInfo.$patch((state) => {
      state.student.stuID = result.record.stuID;
      state.parent.parentID = result.record.parentID;
    });
    // already set graph pw
    if (result.record.active === "true") {
      $goPage("/graph-password/login");
    } else {
      $goPage("/graph-password/first");
    }
  }
};
const logo = ref();
const getLogo = async () => {
  let result = await ApiGetLogo.get();
  let blob = new Blob([result.record], { type: "image/png" });
  let url = URL.createObjectURL(blob);
  logo.value = url;
  console.log(url);
};
const route = useRoute();
const detectAdBlock = async () => {
  // 方法1：檢查廣告 div 是否存在
  // 檢測方式是根據元素的類名或 ID 名稱進行判斷
  var isAdBlockerEnabled = false;
  var testAd = document.createElement("div");
  testAd.innerHTML = "&nbsp;";
  testAd.className = "ad";
  document.body.appendChild(testAd);
  setTimeout(function () {
    if (testAd.offsetHeight === 0) {
      isAdBlockerEnabled = true;
    }
    // document.body.removeChild(testAd);
  }, 100);
  // 可以檢查檔廣告軟體是否擋住了網站上的圖片，或者修改DOM
  // 方法2
  // 可以考慮用一個透明1X1像素
  var adImage = document.createElement("img");
  adImage.src =
    "data:image/gif;base64,R0lGODlhAQABAPAAAAAAAAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="; // 透明的 1x1 像素 GIF 圖片
  adImage.className = "ad-image";
  document.body.appendChild(adImage);
  var isAdImageBlocked =
    adImage.offsetWidth === 0 || adImage.offsetHeight === 0;
  // 方法3
  // uBlock Origin 有提供的 API判別使用者是否有啟用，但是我想偵測的是所有檔廣告軟體
  // // 檢查是否存在 ublock 命名空間，表示 uBlock Origin 已安裝
  // if (typeof ublock !== 'undefined') {
  //   // 檢查 uBlock Origin 是否已啟用
  //   ublock.isInitialized().then(function(initialized) {
  //     if (initialized) {
  //       console.log('uBlock Origin enabled');
  //     } else {
  //       console.log('uBlock Origin disabled');
  //     }
  //   });
  // }
  // 方法4
  // 用request ad
  // 創建一個廣告請求
  // 使用 XMLHttpRequest 物件創建一個簡單的 HTTP GET 請求，並向指定的網址
  // https://www.example.com/ad 發送請求。
  // 需要將其替換為你自己的廣告網址。
  // 檢查廣告請求是否被阻擋
  // 後端模擬
  // 要開CORS不然被擋住status也是0
  // var adRequest = new XMLHttpRequest();
  // adRequest.open("GET", "https://www.example.com/ad", true);
  // adRequest.send();
  var isAdRequestBlocked = false;

  // 檢查所有檢測結果，如果有任何一個檢測結果為 true，則認為廣告擋軟體已啟用
  var isAdBlockerDetected =
    isAdImageBlocked || isAdRequestBlocked || isAdBlockerEnabled;

  // 方法1 2 新增的div與圖片移除
  document.body.removeChild(testAd);
  document.body.removeChild(adImage);
  return isAdBlockerDetected;
};
const device = ref("");
const $getDevice = inject("$getDevice");
onMounted(async () => {
  if (route.query.logout !== undefined) {
    userInfo.$reset();
    localStorage.clear();
  }
  if (route.query.token === "null") {
    console.log("token issue localstorage clear()");
    localStorage.clear();
  }
  // 檔廣告檢測
  let haveAdBlock = await detectAdBlock();
  if (haveAdBlock) {
    console.log("Ad blocker detected!");
  } else {
    console.log("No ad blocker detected.");
  }
  // console.log("isUBlockOriginEnabled = ,", isUBlockOriginEnabled);

  //
  // localStorage.clear();
  if (
    localStorage.getItem("token") !== undefined &&
    localStorage.getItem("token") !== null
  ) {
    let obj = { token: localStorage.getItem("token") };
    $goPage("/ssologin", obj);
  }
  localStorage.setItem("needReload", "true");
  getLogo();
  var ins = route.query.ins;
  console.log("ins = ", ins);
  if (ins === undefined) {
    console.log("update pinia");
    localStorage.setItem("ins", "");
    userInfo.$patch((state) => {
      state.ins = "";
    });
  } else {
    console.log("update pinia");
    localStorage.setItem("ins", ins);
    userInfo.$patch((state) => {
      state.ins = ins;
    });
  }
  global.$patch((state) => {
    state.showNotification = true;
  });
  device.value = $getDevice();
});
</script>
<style lang="scss" scoped>
.msulogo {
  width: 280px;
}
.bg-login-table {
  background-color: #3d1c4b;
  opacity: 0.9;
}

@media screen and (max-width: 380px) {
  .btn-emoji-password .emoji {
    line-height: 40px;
    text-align: center;
    font-size: 1.7rem;
  }
  .container-login .sign-in-form {
    top: 56%;
  }
  .container-login.footer-xl {
    height: 100vh;
    margin-bottom: 0px;
  }
}
@media screen and (max-width: 400px) {
  .container-login.footer-xl {
    height: 100vh;
    margin-bottom: 0px;
  }
}
.login-text-hover {
  color: #ffffff;
}
.login-text-hover:hover {
  color: #32c1db;
}

// 移除可能造成跑版的初始 transform
// 只保留動畫優化相關的樣式
.sign-in-form,
.display-5,
.text-shadow,
.input-group,
.btn-primary,
.login-text-hover,
.msulogo {
  will-change: transform, opacity;
}

// 保持原有的登入框樣式
.bg-login-table {
  background-color: #3d1c4b;
  opacity: 0.9;
}

.msulogo {
  width: 280px;
}

// 其他原有樣式...
</style>
